export enum TipoModelEnum { ENSEMBLE = 1, MULTIML, MODEL, REGRESSION, ENSEMBLE_BOOST, DEEPNET };
